import ContentLayout from '@/layouts/content-layout'
import OrdersView from '@/sections/orders/view/orders-view'

export default function OrdersPage() {
  return (
    <ContentLayout title="คำสั่งซื้อ">
      <OrdersView />
    </ContentLayout>
  )
}
